import { groupLifeProposalsService } from '@/services/proposals/group-life';
import type { GroupLifeRejectProposalAnalysisResponse } from '@/services/proposals/group-life';
import { useMutation, useQueryClient } from '@tanstack/react-query';

type Variables = {
  policyId: string;
  description: string;
};

export function useRejectGroupLifeProposalAnalysis() {
  const queryClient = useQueryClient();

  return useMutation<GroupLifeRejectProposalAnalysisResponse, Error, Variables>({
    mutationKey: ['group-life-proposal', 'reject-analysis'],
    mutationFn: async ({ policyId, description }) => {
      const response = await groupLifeProposalsService.rejectProposalAnalysis(
        policyId,
        description
      );
      if (!response.success || !response.data) {
        throw new Error(response.error || 'Erro ao recusar proposta em análise');
      }
      return response.data;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['proposal-analyses'] });
      queryClient.invalidateQueries({
        queryKey: ['group-life-proposal', variables.policyId],
      });
      queryClient.invalidateQueries({
        queryKey: ['group-life', 'underwriting-messages', variables.policyId],
      });
      queryClient.invalidateQueries({ queryKey: ['proposals'] });
    },
  });
}
